export const themeConfig = {
  cookieKey: "theme",
};

/** Colour scheme stored in the theme cookie. */
export type ThemeMode = "dark" | "light";
